import React from 'react';
import { Checkbox } from '../Checkbox';
import { useTranslate } from '../util';
import { StyledTHCheckbox, StyledTHCheckboxWrapper, StyledTHead, StyledTHeadTR } from './THead.styled';
export function THead(props) {
  var _t;
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(StyledTHead, null, /*#__PURE__*/React.createElement(StyledTHeadTR, {
    isHidden: props.hidden
  }, props.selectable && /*#__PURE__*/React.createElement(StyledTHCheckboxWrapper, {
    isHidden: props.hidden
  }, props.selectable.hidden ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(StyledTHCheckbox, {
    isHidden: props.hidden
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: Boolean(props.selectable.checked),
    disabled: props.selectable.disabled,
    onChange: function onChange(checked) {
      return props.selectable && props.selectable.onChange && props.selectable.onChange(checked);
    },
    "aria-label": (_t = t('citrix-ui:table.select_all')) !== null && _t !== void 0 ? _t : ''
  }))), React.Children.map(props.children, function (child) {
    return /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
      hidden: props.hidden
    });
  })));
}